export const LOAD_POSTS_SUCCESS = 'LOAD_POSTS_SUCCESS';
export const SAVE_POST_SUCCESS = 'SAVE_POST_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const OAUTH_LOGIN_SUCCESS = 'OAUTH_LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const EDIT_POST_SUCCESS = 'EDIT_POST_SUCCESS';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const GET_USER_POSTS_SUCCESS = 'GET_USER_POSTS_SUCCESS';
export const LOAD_TOPUSERS_SUCCESS = 'LOAD_TOPUSERS_SUCCESS';